var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 5,
    width: 8.5,
    height: 8.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-82.4%",
    y: "-58.8%",
    width: "264.7%",
    height: "264.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Excel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8415788,0 L1.43895383,0 C1.20791339,0 1,0.18000635 1,0.427510412 L1,17.5724896 C1,17.7975069 1.18482468,18 1.43895383,18 L14.5610462,18 C14.7920866,18 15,17.8199936 15,17.5724896 L15,4.05001214 C15,3.9375035 14.9537842,3.82499486 14.8844798,3.75749715 L11.1418854,0.112508638 C11.0494922,0.0450109259 10.9570607,0 10.8415788,0 Z",
    id: "Path",
    fill: "#EBF0F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4422303,3.87000579 L14.9537842,3.87000579 C14.9306955,3.82499486 14.9075685,3.78002129 14.8613911,3.75749715 L12.9900939,1.93498422 L11.1418854,0.112508638 C11.0956696,0.0674977121 11.0725809,0.0450109259 11.0263652,0.0225241397 L11.0263652,3.44249538 C11.0032765,3.68999944 11.2111899,3.87000579 11.4422303,3.87000579 Z",
    id: "Path",
    fill: "#D5D6DB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1D7145",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "E",
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: 0.05,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.319,
    y: 12
  }, "E"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.aea7b4ea832732c567118b6c99bf7ee0.svg";
export { ForwardRef as ReactComponent };